import { Component, OnInit } from '@angular/core';
import * as d3 from 'd3';
import { Tier3 } from 'src/app/models/obs/tier3';
import { Section } from 'src/app/models/obs/section';
import { Graphic } from 'src/app/models/obs/graphic';
import { Tier3Service } from 'src/app/services/obs/tier3.service';
import { Message } from 'src/app/models/message';
import { urlEndPoint } from 'src/app/common';
import * as svgfile from './mega.svgdata.json';
import { ErrorHandlingService } from 'src/app/services/util/error-handling.service';
import { Tier1Service } from '../../services/obs/tier1.service';
import { Tier1 } from 'src/app/models/obs/tier1';

@Component({
  selector: 'app-mega',
  templateUrl: './mega.component.html',
  styleUrl: './mega.component.scss'
})
export class MegaComponent implements OnInit {

  idEvenType: string = '4';

  isUploadDir: boolean = false;
  URL: string = urlEndPoint;

  t1: Tier1 = null;
  t3: Tier3[] = [];
  fp: Tier3[] = [];

  sections: Section[] = [];
  msg: Message;

  sT3: Tier3 = null;

  section: Section[] = null;
  isContent: boolean = false;

  img: Graphic[] = null;
  idMegatrend = 7;
  idPrimaryForce = 20;

  constructor(
    private tier1Service: Tier1Service,
    private tier3Service: Tier3Service,
    private errorService: ErrorHandlingService) {
  }

  ngOnInit() {
    this.getTier3ByIdTier1(this.idMegatrend);
    this.getTier1();
  }

  verifiedImgDirectory() {
    if (this.sT3.img != null) {
      (this.sT3.img.substring(1, 7) == 'upload') ? this.isUploadDir = true : this.isUploadDir = false;
    }
  }

  getTier1() {
    this.tier1Service.getOne(this.idMegatrend).subscribe({
      next: res => {
        this.t1 = res['data'];
      },
      error: err => { this.msg = err; }
    });
  }

  getTier3ByIdTier1(id: number) {
    this.tier3Service.getByIdTier1(id).subscribe({
      next: res => {
        this.t3 = res['data'];
        this.getMega(null, this.t3[0].code);
        this.getPrimaryForceByIdT1(this.idPrimaryForce);
      },
      error: err => { this.msg = this.errorService.handleError(err); }
    });
  }

  getPrimaryForceByIdT1(id: number) {
    this.tier3Service.getByIdTier1(id).subscribe({
      next: res => {
        this.fp = res['data'];
        if (this.fp.length > 0) {
          this.t3.push(...this.fp);
        }
        this.drawMegatrends();
      },
      error: err => { this.msg = this.errorService.handleError(err); }
    });
  }

  drawMegatrends() {
    var self = this;
    var svg = d3.select("#megas-draw") //create container
      .append("svg")
      .attr("preserveAspectRatio", "xMinYMin meet")
      .attr("viewBox", "0 0 400 400");

    svgfile.data.forEach(pf => {
      svg.append("path")
        .attr("d", pf.path)
        .style("fill", pf.color)
        .style("fill-opacity", pf.opacity)
        .style("stroke-width", "0px")
        .attr("id", pf.id)
        .attr("class", pf.class);
    });

    svg.selectAll(".fp")
      .on('click', click_m)
      .on('mouseover', mouseover_m)
      .on('mouseout', mouseout_m);

    svg.selectAll(".m")
      .on('click', click_m)
      .on('mouseover', mouseover_m)
      .on('mouseout', mouseout_m);

    svg.append('circle')
      .attr('cx', 199.84)
      .attr('cy', 196.8)
      .attr('r', '53.01px')
      .style('fill', 'white');

    svg.append("svg:image")
      .attr('x', 151.18)
      .attr('y', 148.69)
      .attr('width', 97.56)
      .attr('height', 97.56)
      .attr("xlink:href", "assets/img/mega.png")

    svg.selectAll(".t_m")
      .on('click', click_t_m)
      .on('mouseover', mouseover_t_m)
      .on('mouseout', mouseout_t_m);

    svg.selectAll(".t_pf")
      .on('click', click_t_m)
      .on('mouseover', mouseover_t_m)
      .on('mouseout', mouseout_t_m);


    function click_m() {
      var id = d3.select(this).attr('id');
      var textElement = d3.select("#" + id + "_text");

      d3.selectAll(".t_m")
        .transition()
        .duration(200)
        .attr("transform", "scale(1)")
        .style("opacity", 0.8);

      d3.selectAll(".t_pf")
        .transition()
        .duration(200)
        .attr("transform", "scale(1)");

      textElement
        .transition()
        .duration(200)
        .each(function () {
          var bbox = (this as SVGGraphicsElement).getBBox();
          var cx = bbox.x + bbox.width / 2;
          var cy = bbox.y + bbox.height / 2;
          d3.select(this)
            .attr("transform", "translate(" + cx + "," + cy + ") scale(1.1) translate(" + (-cx) + "," + (-cy) + ")")
            .style("opacity", 1);
        })


      self.getMega(null, id);
      //self.verifiedSections(id);
    }

    function click_t_m() {
      var id = d3.select(this).attr('id').split('_')[0];
      d3.selectAll(".t_m")
        .transition()
        .duration(200)
        .style("opacity", 0.8)
        .attr("transform", "scale(1)");

      d3.selectAll(".t_pf")
        .transition()
        .duration(200)
        .attr("transform", "scale(1)");

      d3.select(this)
        .transition()
        .duration(200)
        .each(function () {
          // Obtener el centro del path
          var bbox = (this as SVGGraphicsElement).getBBox();
          var cx = bbox.x + bbox.width / 2;
          var cy = bbox.y + bbox.height / 2;
          d3.select(this)
            .attr("transform", "translate(" + cx + "," + cy + ") scale(1.1) translate(" + (-cx) + "," + (-cy) + ")")
            .style("opacity", 1);
        });
      self.getMega(null, id);
      //self.verifiedSections(id);
    }

    function mouseout_m() {
      d3.select(this)
        .transition() // Inicia la transición
        .duration(200) // Duración de la transición en milisegundos
        .style("fill-opacity", 1)
        .style("stroke-width", "0px");
    }

    function mouseover_m() {
      d3.select(this)
        .transition() // Inicia la transición
        .duration(200) // Duración de la transición en milisegundos
        .style("stroke", "#FFF")
        .style("stroke-width", "2px")
        .style("cursor", "pointer");
    }

    function mouseout_t_m() {
      d3.select('#' + d3.select(this).attr('id').substring(0, 2))
        .style("stroke-width", "0px");
    }

    function mouseover_t_m() {
      d3.select(this)
        .style("cursor", "pointer");
      d3.select('#' + d3.select(this).attr('id').substring(0, 2))
        .style("fill-opacity", 1)
    }  

  }


  wrap(text, width) {
    text.each(function () {
      var text = d3.select(this),
        words = text.text().split(/\s+/).reverse(),
        word,
        line = [],
        lineNumber = 0,
        lineHeight = 1.1, // ems
        x = text.attr("x"),
        y = text.attr("y"),
        dy = 0, //parseFloat(text.attr("dy")),
        tspan = text.text(null)
          .append("tspan")
          .attr("x", x)
          .attr("y", y)
          .attr("dy", dy + "em");
      while (word = words.pop()) {
        line.push(word);
        tspan.text(line.join(" "));
        if (tspan.node().getComputedTextLength() > width) {
          line.pop();
          tspan.text(line.join(" "));
          line = [word];
          tspan = text.append("tspan")
            .attr("x", x)
            .attr("y", y)
            .attr("dy", ++lineNumber * lineHeight + dy + "em")
            .text(word);
        }
      }
    });
  }

  getMega(t: Tier3, d: any) {
    this.t3.forEach(o => {
      if (o.code == d) {
        this.sT3 = o;
        if (this.sT3.img != null)
          this.verifiedImgDirectory();
      }
    });
  }

}

